import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';

const StyledSkeleton = styled(Skeleton)`
  height: ${spacing.plusQuarter};
  min-width: ${spacing.double};
`;

export const RowSkeleton = () => (
  <>
    <StyledSkeleton />
    <StyledSkeleton />
  </>
);
